import { useLang } from "@/lang";

const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee || [];
  const doubled = [...items, ...items, ...items, ...items];

  return (
    <div data-testid="editorial-marquee" className="relative py-6 border-y border-amber-500/10 overflow-hidden bg-surface/40">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {doubled.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-serif italic text-xl sm:text-2xl text-zinc-500 px-6">
                {item}
                <span className="ml-12 text-champagne/50 not-italic text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
